import {ADO} from 'actions/ado'
import {SET_EXPERIMENTS, SET_CUSTOM_EXPERIMENTS, UPDATE_CUSTOM_EXPERIMENTS} from 'actions/experiments'
import { PERFORM_REGISTER } from 'actions/register'

export default (state = null, action) => {
    switch (action.type) {
        case ADO:
        case UPDATE_CUSTOM_EXPERIMENTS:
            if (!action.payload.data.experiments) {
                return state
            }
            return Object.assign({}, state, action.payload.data.experiments);
        case SET_EXPERIMENTS:
            return Object.assign({}, state, action.payload.data.experiments);
        case SET_CUSTOM_EXPERIMENTS:
            return Object.assign({}, state, action.payload);
        case PERFORM_REGISTER:
            return Object.assign({}, state, action.payload.data.experiments);
    }

    return state;
}
